import { useSyncExternalStore } from 'react';

/**
 * An element of the shell that surfaces rendered elsewhere portal into: the title bar's slots,
 * and the sidebar and content area a library page fills. Library pages render beside the shell
 * rather than inside it, so slots live in module stores instead of React context.
 */
export type ElementSlot = {
  /** Ref callback for the slot element. */
  set: (element: HTMLDivElement | null) => void;
  /** Hook: the slot element, once mounted. */
  useElement: () => HTMLDivElement | null;
};

export function createElementSlot(): ElementSlot {
  let slot: HTMLDivElement | null = null;
  const listeners = new Set<() => void>();
  const subscribe = (listener: () => void) => {
    listeners.add(listener);
    return () => listeners.delete(listener);
  };
  return {
    set(element) {
      if (slot === element) return;
      slot = element;
      for (const listener of listeners) listener();
    },
    useElement() {
      return useSyncExternalStore(
        subscribe,
        () => slot,
        () => null,
      );
    },
  };
}
